import { render, staticRenderFns } from "./StudentProfilePreferredLanguage.vue?vue&type=template&id=67882a57&scoped=true&"
import script from "./StudentProfilePreferredLanguage.vue?vue&type=script&lang=js&"
export * from "./StudentProfilePreferredLanguage.vue?vue&type=script&lang=js&"
import style0 from "./StudentProfilePreferredLanguage.vue?vue&type=style&index=0&id=67882a57&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67882a57",
  null
  
)

export default component.exports